import React, { Fragment, useEffect, useRef, useState } from 'react';

import Icon from '@material-ui/core/Icon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import UseDynamicIcon from 'utils/UseDynamicIcon';

import customInputStyle from 'assets/jss/material-kit-react/components/customInputStyle.jsx';
import config from 'config';
import superagent from 'superagent';

const KMEstablishmentCampus = props => {
    const {
        classes,
        behaviors,
        forceValue,
        fullwidth,
        establishmentId,
        initialValue,
        handleInputChange,
        ...onlyOtherProps
    } = props;

    const flagFirstRender = useRef(true);

    const initialName = behaviors.name;

    const [establishmentCampuses, setEstablishmentCampuses] = useState([]);
    const [establishmentCampusId, setEstablishmentCampusId] = useState(forceValue || initialValue || '');
    const [flagLoading, setFlagLoading] = useState(true);
    const [errorText] = useState('');

    const behaviorState = {
        className: behaviors.className,
        errorTextMessage: behaviors.errorTextMessage,
        pattern: behaviors.pattern,
        hintText: behaviors.hintText,
        label: behaviors.label,
        name: initialName,
        success: false,
        placeholder: behaviors.placeholder,
        noCheck: behaviors.noCheck || false,
        required: behaviors.required || false,
        helperText: behaviors.helperText,
        id: behaviors.id || initialName,
    };

    const fetchEstablishmentCampuses = async currentEstablishmentId => {
        setFlagLoading(true);

        if (!currentEstablishmentId) {
            setEstablishmentCampuses([]);
            setFlagLoading(false);
            return;
        }

        let apiClientUrl = config.front.establishmentCampus.url;
        apiClientUrl += `?establishmentId=${currentEstablishmentId}`;
        apiClientUrl += '&sort=establishmentCampusLabel_asc';

        let apiResponseNetwork;

        try {
            apiResponseNetwork = await superagent
                .get(apiClientUrl)
                .set('Content-Type', 'application/json')
                .set('Accept', 'application/json')
                .set('X-JWT', window.localStorage.getItem('JWT'))
                .withCredentials();
        } catch (requestError) {
            setEstablishmentCampuses([]);
            setFlagLoading(false);
            return;
        }

        const responseKeepapi = apiResponseNetwork.body;

        if (responseKeepapi.code !== 'ok') {
            setEstablishmentCampuses([]);
            setFlagLoading(false);
            return;
        }

        setEstablishmentCampuses(responseKeepapi.data || []);
        setFlagLoading(false);
    };

    useEffect(() => {
        if (!flagFirstRender.current) {
            setEstablishmentCampusId('');

            if (handleInputChange) {
                handleInputChange('');
            }
        }

        flagFirstRender.current = false;

        fetchEstablishmentCampuses(establishmentId);
    }, [establishmentId]);

    const validEstablishmentCampuses = establishmentCampuses.filter(
        establishmentCampus => {
            return (
                !!establishmentCampus.establishmentCampusId &&
                !!establishmentCampus.establishmentCampusLabel
            );
        }
    );

    const renderRdvMedicalType = establishmentCampus => {
        if (!establishmentCampus || !establishmentCampus.rdvMedicaltype) {
            return null;
        }

        return (
            <span
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4
                }}
            >
                {!!establishmentCampus.typingMaterialIcon && (
                    <Icon fontSize="small">
                        {establishmentCampus.typingMaterialIcon}
                    </Icon>
                )}

                <span>
                    {establishmentCampus.rdvMedicaltype}
                </span>
            </span>
        );
    };

    const handleChange = event => {
        const selectedEstablishmentCampusId = event.target.value || '';

        setEstablishmentCampusId(selectedEstablishmentCampusId);

        if (handleInputChange) {
            handleInputChange(selectedEstablishmentCampusId);
        }
    };

    const renderValue = selectedEstablishmentCampusId => {
        if (!selectedEstablishmentCampusId) {
            return behaviorState.placeholder || '';
        }

        const selectedEstablishmentCampus = validEstablishmentCampuses.find(
            establishmentCampus => {
                return selectedEstablishmentCampusId === establishmentCampus.establishmentCampusId;
            }
        );

        if (!selectedEstablishmentCampus) {
            return behaviorState.placeholder || '';
        }

        return (
            <Fragment>
                {selectedEstablishmentCampus.establishmentCampusLabel}
            </Fragment>
        );
    };

    if (flagLoading) {
        return null;
    }

    if (validEstablishmentCampuses.length === 0) {
        return null;
    }

    const selectedEstablishmentCampus = validEstablishmentCampuses.find(
        establishmentCampus => {
            return establishmentCampusId === establishmentCampus.establishmentCampusId;
        }
    );

    const rowsMenuItems = validEstablishmentCampuses.map(
        establishmentCampus => {
            return (
                <MenuItem
                    key={establishmentCampus.establishmentCampusId}
                    value={establishmentCampus.establishmentCampusId}
                >
                    <ListItemText
                        classes={{ primary: classes.primary }}
                        inset
                        primary={establishmentCampus.establishmentCampusLabel}
                        secondary={renderRdvMedicalType(establishmentCampus)}
                    />
                </MenuItem>
            );
        }
    );

    return (
        <FormControl
            fullWidth={fullwidth}
            className={classes.formControl}
            {...onlyOtherProps}
        >
            <InputLabel htmlFor={behaviorState.id}>
                {behaviorState.label}
            </InputLabel>

            <Select
                autoWidth
                displayEmpty
                id={behaviorState.id}
                renderValue={renderValue}
                name={initialName}
                value={establishmentCampusId}
                onChange={handleChange}
                className={classes.textField}
                margin="normal"
                errortext={errorText}
                error={errorText !== ''}
                required={behaviorState.required}
                {...onlyOtherProps}
            >
                <MenuItem value="">
                    <ListItemText
                        classes={{ primary: classes.primary }}
                        inset
                        primary="Aucun campus"
                    />
                </MenuItem>

                {rowsMenuItems}
            </Select>

            {!!selectedEstablishmentCampus && !!selectedEstablishmentCampus.rdvMedicaltype && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                        marginTop: 6,
                        fontSize: 13,
                        color: 'rgba(0, 0, 0, 0.54)'
                    }}
                >
                    {!!selectedEstablishmentCampus.typingMaterialIcons && (
                        <UseDynamicIcon iconName={selectedEstablishmentCampus.typingMaterialIcons} />
                    )}

                    {!selectedEstablishmentCampus.typingMaterialIcons && !!selectedEstablishmentCampus.typingMaterialIcon && (
                        <UseDynamicIcon iconName={selectedEstablishmentCampus.typingMaterialIcon} />
                    )}

                    <span>
                        {selectedEstablishmentCampus.rdvMedicaltype}
                    </span>
                </div>
            )}
        </FormControl>
    );
};

export default withStyles(customInputStyle)(KMEstablishmentCampus);
